import { Box, Grid } from '@mui/joy';
import { useEffect, useState } from 'react';
import useEvents from '../../hooks/useEvents';
import { deleteEvent } from '../../redux/actions/eventActions';
import { Event } from '../../types/events/event';
import { UpcomingEvents } from '../homepage/upcomingEvents';
import MainEventsContent from './MainEventsContent';
import { EventForm } from './modal/form';

const Index = () => {
  const eventsquery = useEvents();
  const [date, setDate] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const [showModal, setShowModal] = useState(false);

  const deleteSelectedEvent = async () => {
    if (!selectedEvent) return;
    await deleteEvent(selectedEvent._id);
    setShowModal(false);
    setSelectedEvent(null);
  };

  useEffect(() => {
    if (!showModal) {
      eventsquery.refetch();
    }
  }, [showModal]);

  return (
    <>
      {/* Create modal */}
      <EventForm open={showModal} setOpen={setShowModal} />

      <Grid container>
        <Grid xs={12} lg={9}>
          <Box
            sx={{
              padding: '1rem',
            }}
          >
            <MainEventsContent
              events={eventsquery.data || []}
              setSelectedEvent={setSelectedEvent}
              setShowModal={setShowModal}
              dateFilter={date}
              setDateFilter={setDate}
            />
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Index;
